export const ONBOARDING_STEPS = ['welcome', 'selfie'] as const;
export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];
export const ONBOARDING_STEP_ALIASES = {
  howItWorks: 'selfie'
} as const satisfies Record<string, OnboardingStep>;